export default __webpack_public_path__ + "static/media/firebase-logo.5857e021.png";